import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "12",
  height: "12",
  viewBox: "0 0 12 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = ["stroke"]
const _hoisted_3 = ["stroke"]

import { withDefaults } from 'vue';

interface IProps {
  color?: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'DeletexIcon',
  props: {
    color: {}
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _createElementVNode("line", {
      x1: "1.41421",
      y1: "1",
      x2: "10.7349",
      y2: "10.3207",
      stroke: _ctx.color || '#212529',
      "stroke-width": "2",
      "stroke-linecap": "round"
    }, null, 8, _hoisted_2),
    _createElementVNode("line", {
      x1: "1.26465",
      y1: "10.3206",
      x2: "10.5853",
      y2: "0.999981",
      stroke: _ctx.color || '#212529',
      "stroke-width": "2",
      "stroke-linecap": "round"
    }, null, 8, _hoisted_3)
  ]))
}
}

})